const API_BASE_URL = import.meta.env.VITE_API_URL?.replace(/\/$/, '');

export type PricingPlan = {
  name: string;
  price: string;
  cadence: string;
  description: string;
  features: string[];
  cta: string;
  accent?: string;
  popular?: boolean;
  stripePriceId?: string;
  analyticsKey?: string;
  ctaLink?: string;
};

export async function fetchPlans(): Promise<PricingPlan[]> {
  if (!API_BASE_URL) {
    throw new Error('VITE_API_URL is required to load pricing plans.');
  }

  const response = await fetch(`${API_BASE_URL}/v1/plans`, {
    headers: { 'Content-Type': 'application/json' },
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(`Plans fetch failed (${response.status}): ${text}`);
  }

  const payload = await response.json();
  if (Array.isArray(payload?.data)) return payload.data as PricingPlan[];
  if (Array.isArray(payload)) return payload as PricingPlan[];
  throw new Error('Plans response malformed.');
}
